import _ from 'lodash'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import { Helmet } from 'react-helmet'
import 'es6-promise/auto'
import 'setimmediate'
import axios from 'axios'
import message from 'antd/lib/message'

import l8n, { getLocaleFromPath } from 'l8n'
import { history, store } from 'store'
import {rejectAuth} from "./ducks/auth"

import registerServiceWorker from 'registerServiceWorker'

import Layout from 'components/CustomComponents/Layout'
import Localizer from 'components/CustomComponents/Localization/Localizer'
import CookieConsent from 'components/CustomComponents/CookieConsent/containers/Banner'

import 'resources/_antd.less' // redefinition AntDesign variables
import 'bootstrap/dist/css/bootstrap.min.css' // bootstrap styles

import 'resources/AntStyles/AntDesign/antd.cleanui.scss'
import 'resources/CleanStyles/Core/core.cleanui.scss'
import 'resources/CleanStyles/Vendors/vendors.cleanui.scss'

const getErrorMsg = msg => {
  if (_.isArray(msg)) {
    return _.filter(_.map(msg, getErrorMsg))
  }
  return !!l8n[msg] ? l8n[msg] : null
}

// Все ошибки выводятся в виде сообщений вверху страницы.
const errorHandler = error => {
  if (error) {
    // Обычные ошибки
    handleSendingError(error)
    // Ответы от API
    const response = error.response ? error.response : error
    handleApiError(response, 'error_list', 'error')
    handleApiError(response, 'warning_list', 'warning')
    handleApiError(response, 'violation_list', 'warning')
  }
  // Неудачные запросы возвращают false
  return Promise.resolve(error)
}

const handleSendingError = error => {
  if (_.has(error, 'message')) {
    const messageText = getErrorMsg(error.message)
    if (_.isEmpty(messageText)) {
      console.error(error.message)
      return
    }
    message.error(messageText, 5)
  }
}

const handleApiError = (response, errorKey, errorLevel) => {
 if (_.has(response, `data.${errorKey}`)) {
   let messageText = getErrorMsg(response.data[errorKey])
   if (_.isEmpty(messageText)) {
     messageText = l8n['p_pl_unknown_error']
   }
   message[errorLevel](messageText, 5)
 }
}

// Перехватываем все сообщения об ошибках из запросов.
// Запрос всегда считатеся успешным, т.е. axios() всегда возвращает request или true.
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
axios.interceptors.response.use(function (response) {
  let ok = _.get(response, 'data.ok', true)
  // Ответы отлюбой апихи с ok=false обрабатываются как ошибки
  if (!ok){
    return errorHandler(response)
  }
  return response
}, function (error) {
  if(error.response && error.response.status === 401){
    store.dispatch(rejectAuth())
  }
  return errorHandler(error)
});

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <div>
        <Helmet titleTemplate={`${getLocaleFromPath(window.location.pathname) === 'ru' ? 'Jivo' : 'Jivochat'} Affiliate - %s`}/>
        <Localizer/>
        <Layout/>
        <CookieConsent />
      </div>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()

export default history



// WEBPACK FOOTER //
// ./src/index.js